/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

!function(i){function t(t){var e=0;return t.children("li").each(function(){e+=i(this).outerWidth(!0)}),e}function e(t){return Math.max.apply(Math,t.children().map(function(){return i(this).width()}).get())}function s(i){var t=i.data("settings")||{direction:"left",speed:50},e=i.children().first(),s=Math.abs(-i.css(t.direction).replace("px","").replace("auto","0")-e.outerWidth(!0)),n=1e3*s/t.speed,r={};return r[t.direction]=i.css(t.direction).replace("px","").replace("auto","0")-s,{css:r,time:n}}function n(i){var t=i.data("settings")||{direction:"left"};i.css("transition-duration","0s").css(t.direction,"0");var e=i.children().first();e.hasClass("webticker-init")?e.remove():i.children().last().after(e)}function r(i,t){var e=i.data("settings")||{direction:"left"};"undefined"==typeof t&&(t=!1),t&&n(i);var a=s(i);i.animate(a.css,a.time,"linear",function(){i.css(e.direction,"0"),r(i,!0)})}function a(i,t){"undefined"==typeof t&&(t=!1),t&&n(i);var e=s(i),r=e.time/1e3;r+="s",i.css(e.css).css("transition-duration",r)}function c(t,e,s){var n=[];i.get(t,function(t){var r=i(t);r.find("item").each(function(){var t=i(this),e={title:t.find("title").text(),link:t.find("link").text()},s='<li><a href="'+e.link+'"">'+e.title+"</a></li>";n+=s}),s.webTicker("update",n,e)})}function l(s,n){if(s.children("li").length<1)return window.console,!1;var r=s.data("settings");r.duplicateLoops=r.duplicateLoops||0,s.width("auto");var a=0;s.children("li").each(function(){a+=i(this).outerWidth(!0)});var c,l=s.find("li:first").height();if(r.duplicate){c=e(s);for(var o=0;a-c<s.parent().width()||1===s.children().length||o<r.duplicateLoops;){var d=s.children().clone();s.append(d),a=0,a=t(s),c=e(s),o++}r.duplicateLoops=o}else{var h=s.parent().width()-a;h+=s.find("li:first").width(),s.find(".ticker-spacer").length>0?s.find(".ticker-spacer").width(h):s.append('<li class="ticker-spacer" style="float: '+r.direction+";width:"+h+"px;height:"+l+'px;"></li>')}r.startEmpty&&n&&s.prepend('<li class="webticker-init" style="float: '+r.direction+";width:"+s.parent().width()+"px;height:"+l+'px;"></li>'),a=0,a=t(s),s.width(a+200);var f=0;for(f=t(s);f>=s.width();)s.width(s.width()+200),f=0,f=t(s);return!0}var o=function(){var i=document.createElement("p").style,t=["ms","O","Moz","Webkit"];if(""===i.transition)return!0;for(;t.length;)if(t.pop()+"Transition"in i)return!0;return!1}(),d={init:function(t){return t=jQuery.extend({speed:50,direction:"left",moving:!0,startEmpty:!0,duplicate:!1,rssurl:!1,hoverpause:!0,rssfrequency:0,updatetype:"reset",transition:"linear",height:"30px",maskleft:"",maskright:"",maskwidth:0},t),this.each(function(){jQuery(this).data("settings",t);var e=jQuery(this),s=e.wrap('<div class="mask"></div>');s.after('<span class="tickeroverlay-left">&nbsp;</span><span class="tickeroverlay-right">&nbsp;</span>');var n,d=e.parent().wrap('<div class="tickercontainer"></div>');if(i(window).resize(function(){clearTimeout(n),n=setTimeout(function(){console.log("window was resized"),l(e,!1)},500)}),e.children("li").css("white-space","nowrap"),e.children("li").css("float",t.direction),e.children("li").css("padding","0 7px"),e.children("li").css("line-height",t.height),s.css("position","relative"),s.css("overflow","hidden"),e.closest(".tickercontainer").css("height",t.height),e.closest(".tickercontainer").css("overflow","hidden"),e.css("float",t.direction),e.css("position","relative"),e.css("font","bold 10px Verdana"),e.css("list-style-type","none"),e.css("margin","0"),e.css("padding","0"),""!==t.maskleft&&""!==t.maskright){var h='url("'+t.maskleft+'")';d.find(".tickeroverlay-left").css("background-image",h),d.find(".tickeroverlay-left").css("display","block"),d.find(".tickeroverlay-left").css("pointer-events","none"),d.find(".tickeroverlay-left").css("position","absolute"),d.find(".tickeroverlay-left").css("z-index","30"),d.find(".tickeroverlay-left").css("height",t.height),d.find(".tickeroverlay-left").css("width",t.maskwidth),d.find(".tickeroverlay-left").css("top","0"),d.find(".tickeroverlay-left").css("left","-2px"),h='url("'+t.maskright+'")',d.find(".tickeroverlay-right").css("background-image",h),d.find(".tickeroverlay-right").css("display","block"),d.find(".tickeroverlay-right").css("pointer-events","none"),d.find(".tickeroverlay-right").css("position","absolute"),d.find(".tickeroverlay-right").css("z-index","30"),d.find(".tickeroverlay-right").css("height",t.height),d.find(".tickeroverlay-right").css("width",t.maskwidth),d.find(".tickeroverlay-right").css("top","0"),d.find(".tickeroverlay-right").css("right","-2px")}else d.find(".tickeroverlay-left").css("display","none"),d.find(".tickeroverlay-right").css("display","none");e.children("li").last().addClass("last");var f=l(e,!0);t.rssurl&&(c(t.rssurl,t.type,e),t.rssfrequency>0&&window.setInterval(function(){c(t.rssurl,t.type,e)},1e3*t.rssfrequency*60)),o?(e.css("transition-timing-function",t.transition),e.css("transition-duration","0s").css(t.direction,"0"),f&&a(e,!1),e.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend",function(t){return!!e.is(t.target)&&void a(i(this),!0)})):f&&r(i(this)),t.hoverpause&&e.hover(function(){if(o){var e=i(this).css(t.direction);i(this).css("transition-duration","0s").css(t.direction,e)}else jQuery(this).stop()},function(){jQuery(this).data("settings").moving&&(o?a(i(this),!1):r(e))})})},stop:function(){var t=i(this).data("settings");if(t.moving)return t.moving=!1,this.each(function(){if(o){var e=i(this).css(t.direction);i(this).css("transition-duration","0s").css(t.direction,e)}else i(this).stop()})},cont:function(){var t=i(this).data("settings");if(!t.moving)return t.moving=!0,this.each(function(){o?a(i(this),!1):r(i(this))})},transition:function(t){var e=i(this);o&&e.css("transition-timing-function",t)},update:function(e,s,n,r){s=s||"reset","undefined"==typeof n&&(n=!0),"undefined"==typeof r&&(r=!1),"string"==typeof e&&(e=i(e));var a=i(this);a.webTicker("stop");var c=i(this).data("settings");if("reset"===s)a.html(e),l(a,!0);else if("swap"===s){var o,d,h,f;if(window.console,a.children("li").length<1)a.html(e),a.css(c.direction,"0"),l(a,!0);else if(c.duplicate===!0){a.children("li").addClass("old");for(var p=e.length-1;p>=0;p--)o=i(e[p]).data("update"),d=a.find('[data-update="'+o+'"]'),d.length<1?n&&(0===a.find(".ticker-spacer:first-child").length&&a.find(".ticker-spacer").length>0?a.children("li.ticker-spacer").before(e[p]):(h=i(e[p]),p===e.length-1&&h.addClass("last"),a.find("last").after(h),a.find("last").removeClass("last"))):a.find('[data-update="'+o+'"]').replaceWith(e[p]);a.children("li.webticker-init, li.ticker-spacer").removeClass("old"),r&&a.children("li").remove(".old"),f=0,f=t(a),a.width(f+200),a.find("li.webticker-init").length<1&&(c.startEmpty=!1),a.html(e),a.children("li").css("white-space","nowrap"),a.children("li").css("float",c.direction),a.children("li").css("padding","0 7px"),a.children("li").css("line-height",c.height),l(a,!0)}else{a.children("li").addClass("old");for(var u=0;u<e.length;u++)o=i(e[u]).data("update"),d=a.find('[data-update="'+o+'"]'),d.length<1?n&&(0===a.find(".ticker-spacer:first-child").length&&a.find(".ticker-spacer").length>0?a.children("li.ticker-spacer").before(e[u]):(h=i(e[u]),u===e.length-1&&h.addClass("last"),a.find(".old.last").after(h),a.find(".old.last").removeClass("last"))):a.find('[data-update="'+o+'"]').replaceWith(e[u]);a.children("li.webticker-init, li.ticker-spacer").removeClass("old"),a.children("li").css("white-space","nowrap"),a.children("li").css("float",c.direction),a.children("li").css("padding","0 7px"),a.children("li").css("line-height",c.height),r&&a.children("li").remove(".old"),f=0,f=t(a),a.width(f+200)}}a.webTicker("cont")}};i.fn.webTicker=function(t){return d[t]?d[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void i.error("Method "+t+" does not exist on jQuery.webTicker"):d.init.apply(this,arguments)}}(jQuery);


$( document ).ready(function() {
  
  // SOLD OUT 2021
  /*
  $( '#main' ).on("click",".ColorSwatch__Soldout",function (event) {    
    $(this).find(".ColorSwatch").addClass("soldout-active");
    /*
    var soldouttext = "The 2021 is sold out! <a style='text-decoration: underline;' href='https://goclove.attn.tv/p/bCI/landing-page'>Click here</a> to be the first to know about future drops.";
	$("#soldout-color").html(soldouttext).show();
    */
  /*
    $("#add-to-cart-buttons").hide();
    $("#add-to-cart-message").hide();
    $(".modal-buttons").hide();
    //$("#modal-buttons").insertAfter($("#back-in-stock-form"));
    //$(".Product__Tabs").insertAfter($("#back-in-stock-form"));
    $(".ProductForm__Option:nth-of-type(2)").hide();
    $("#pre-order-shipping-date").hide();
    $('.ColorSwatch__Radio').each( function(){        
      $(this).prop("checked",false);
    });
  });
  */  
  
  // THIS IS ALSO CONTROLLED IN THEME.JS "_updateAddToCartButton"
  $( '#main' ).on("click",".SizeSwatch",function (event) {

    // SHOW SOLD OUT COLORS //
    // ADD "SOLD OUT CLASS" to any color swatches that aren't available in the selected size.
    var size = $(this).html();
    $( "[data-instock]" ).each(function() {
      var available = false;
      var instock = $(this).attr("data-instock").split(",");
      $.each(instock,function(i){
         if(instock[i] == size){
           available = true;
         }
      });
      if(available == false){
        $(this).addClass("soldout");
      } else {
        $(this).removeClass("soldout");
      }
    });
    
   	if($(this).parent().hasClass("soldout")){
    	var button = $(this).parent().parent().parent().parent().parent().find(".Sticky__AddToCart");
    	button.prop("disabled", true).addClass("Button--disabled").text('Sold Out'); 
        $("#pre-order-shipping-date").hide();
      	$("#add-to-cart-buttons").hide();
      	$("#add-to-cart-message").hide();
      	//$(".modal-buttons").hide();
      	//$("#modal-buttons-container").insertAfter($("#back-in-stock-form"));
      	//$(".Product__Tabs").insertAfter($("#back-in-stock-form"));
		$("#back-in-stock-form").show();
      
    } else if($(this).parent().hasClass("preorder")){
        var addtocarttext = 'Pre-order';
   		var button = $(this).parent().parent().parent().parent().parent().find(".Sticky__AddToCart");
       	button.prop("disabled", false).removeClass("Button--disabled").text(addtocarttext); 
        $("#pre-order-shipping-date").show();
      	$("#add-to-cart-buttons").show();
      	$("#add-to-cart-message").show();
      	//$(".modal-buttons").show();
      	//$(".Product__Tabs").insertBefore($("#back-in-stock-form"));
      	//$("#modal-buttons-container").insertBefore($("#back-in-stock-form"));
		$("#back-in-stock-form").hide();
    } else {
        var addtocarttext = 'Add to Cart';
   		var button = $(this).parent().parent().parent().parent().parent().find(".Sticky__AddToCart");
       	button.prop("disabled", false).removeClass("Button--disabled").text(addtocarttext); 
        $("#pre-order-shipping-date").hide();
      	$("#add-to-cart-buttons").show();
      	$("#add-to-cart-message").show();
      	//$(".modal-buttons").show();
      	//$(".Product__Tabs").insertBefore($("#back-in-stock-form"));
      	//$("#modal-buttons-container").insertBefore($("#back-in-stock-form"));
		$("#back-in-stock-form").hide();
    }    
  });
  /*
  $( '#sidebar-cart' ).on("click",".SizeSwatch",function (event) {
    $("#drawer-cart-submit").delay(100).click();
  });
  */


  
  /*
  $( '.Product__InfoWrapper' ).on("click","#MainForm__AddToCart",function (event) {
  	$(window).scrollTop(0);

  });
  $( 'body' ).on("click","#open-drawer-cart",function (event) {
  	$(window).scrollTop(0);
  });
  */
  
  
  
  // SHOP MENU - DISABLED
  /*
  $( ".ShopMenu .SizeSwatch" ).click(function() {
    var product = $(this).attr("data-product");
    var variant = $(this).attr("data-variant");
    var sex = ".shop-menu-" + $(this).attr("data-sex");
    var select = sex + " #shopmenu-product-select-" + product;
    $(select).val(variant);
    $(select).trigger("change");  
  });

  $( ".ShopMenu .ProductItem__ColorSwatchItem" ).hover(function() {
  	$(this).find(".ColorSwatch__Radio").prop("checked",true).trigger("change");
  });
  
  $( ".ShopMenu .ColorSwatch__Radio" ).change(function() {
    var product = $(this).attr("data-product");
    var sex = ".shop-menu-" + $(this).attr("data-sex");
    var select = sex + " .ColorSwatch__Radio";
  	$(select).each(function() {

      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    var hasclass = "shop-menu-"+product;
    var select = sex + " .shop-menu-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });
  */ 
  

  // QUICKSHOP 
  /*
    VARIANT SELECTION DISABLED
    $( ".quickshop .SizeSwatch" ).click(function() {
      var product = $(this).attr("data-product");
      var variant = $(this).attr("data-variant");
      var select = "#product-select-" + product;
      $(select).val(variant);
      $(select).trigger("change");    	
    });
  */
  /*
  $( ".ProductItem__ImageWrapper" ).hover(function() {
    $( this ).find(".ProductItem-addtocart").show();
  }, function() {
    $( this ).find(".ProductItem-addtocart").hide();
  }); 
  */
  $(document).on('click','.ProductItem-addtocart-button',function(e){
    e.preventDefault();
    var ID = $(this).attr("data-variant");
    console.log(ID);
    var button = this;
    button.innerHTML = "Adding...";
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(this).attr("data-variant")
      },
      dataType: 'json',
      success: function (data){
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
        setTimeout(function () {
          button.innerHTML = "Add to Cart";
        }, 2500);
      },
      error: function () {
        button.innerHTML = "Out of Stock";
        /*
        setTimeout(function () {
          button.innerHTML = "Not available";
        }, 2500);
        alert("This product is no longer available.")
        */
      }

    });
  });
  
  $( '.ProductItem-quickadd-socks' ).on("click",".SizeSwatch",function (event) {
    var variant = $(this).attr("data-variant");
    var button = $(this).parent().parent().parent().parent().find(".ProductItem-addtocart-button");
    button.attr("data-variant", variant);
    button.show();
  });
  
  $(document).on('click','.drawer-cart-addtocart',function(e){
    e.preventDefault();
    var ID = $(this).attr("data-variant");
    console.log(ID);
    var button = this;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(this).attr("data-variant")      
      },
      dataType: 'json',
      success: function (data){
        document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
        /*
        setTimeout(function () {
          button.innerHTML = "Add to Cart";
        }, 2500);
        */
      },
      error: function () {
        /*
        button.innerHTML = "Out of Stock";
        */
      }

    });
  });


  // SCROLL TO TOP OF PAGE
  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  // PRESS HOVER
  $(".TestimonialNav__Item").hover(function() {
    $(this).trigger("click");
  });
  
// EXPAND
  function checkVisible( elm, eval ) {
      eval = eval || "visible";
      var vpH = $(window).height(), // Viewport Height
          st = $(window).scrollTop(), // Scroll Top
          y = $(elm).offset().top,
          elementHeight = $(elm).height();

      if (eval == "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
      if (eval == "above") return ((y < (vpH + st)));
  }   

  var scrollPos = 0;
  window.addEventListener('scroll', function(){
    //if ((document.body.getBoundingClientRect()).top > scrollPos){
    //} else {
    
      $('.video').each( function(){        
          if (checkVisible($(this))) {
            if($(this).hasClass("firstplayed")){
            } else {
              $(this)[0].currentTime = 0;
              $(this)[0].play();
              $(this).addClass("firstplayed");
            }
          }
      }); 
    
      $('.js-scrollFade').each( function(){        
          var id = $(this).attr("id");
          var tester = document.getElementById(id);
          if (checkVisible($(this))) {
            $(this).addClass("is-in-view");
          }
      }); 
    
      $('.js-scrollFade-all').each( function(){        
          var id = $(this).attr("id");
          var tester = document.getElementById(id);
          if (checkVisible($(this))) {
            $(this).addClass("is-in-view");
          }
      }); 

    
      // SCROLL DOWN
      $('.expand').each( function(){ 
        /*
        var speed = 0.01555;
        */
        var speed = 0.01;

        var width = $( window ).width();
        /*
        if(width > 1500){
          speed = speed;
        } else if(width < 641){
          speed = speed/2;
        }
        */
        var id = $(this).attr("id");
        var tester = document.getElementById(id);
        if (checkVisible($(this))) {
          var matrixRegex = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*0,\s*0\)/,
          matches = $(this).css('-webkit-transform').match(matrixRegex);
          var transform = parseFloat(matches[1]);
          if(transform < 1){
            transform = transform + speed;
            transform = "matrix("+transform+", 0, 0, "+transform+", 0, 0)";
            var transform =  $(this).css("transform", transform);
          }
        }
      }); 
    //}
    scrollPos = (document.body.getBoundingClientRect()).top;
  });

  // DRAWER CART
  //$( " .ColorSwatch__Radio" ).change(function() {
  $( "body" ).on("change",".drawer-add-to-your-order .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");

    var select = ".drawer-add-to-your-order .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
                //$("#drawer-cart-submit").prop("disabled", true).addClass("Button--disabled").text("Select a Size");                                                  
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
          //$("#drawer-cart-submit").prop("disabled", false).removeClass("Button--disabled").text("Add to Bag");                                                  
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-"+product;
    var select = ".drawer-add-to-your-order-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });

  $( "body" ).on("click","#drawer-cart-submit",function (event) {
  //$( "#drawer-cart-submit" ).click(function(event) {
  		//event.preventDefault();
    	var product = '';
        $(".drawer-add-to-your-order .ColorSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		product = $(this).attr("data-product");
          }          
  		}); 
    	var size = '';
        $(".drawer-add-to-your-order .SizeSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		size = $(this).val();
          }              
  		}); 
    	var variant = '';
        $(".drawer-cart-submit").each(function(){
          if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
    		variant = $(this).attr("data-variant");
          }          
  		}); 
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: variant,
                properties: { "_bundle": true }
            },
          async: false
        });        
    	//window.location = '/checkout';
        //window.location = '/cart';
  }); 
  
  $( '#sidebar-cart' ).on("click","#drawer-cart-submit-dummy",function (event) {
  	event.preventDefault();
    $(this).hide();
    $("#drawer-cart-sock-sizes").show();
    //$('#sidebar-cart').animate({scrollTop: $("#drawer-cart-sock-sizes").offset().top},'fast');
    //$('#sidebar-cart .Drawer__Main').animate({scrollTop: $("#drawer-cart-sock-sizes").offset().top},'fast');
  });

  $( "body" ).on("change","#slider-cloveys .drawer-add-to-your-order .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit").trigger("click");
  });  

  /* UNDERSCRUB MODULE */
  $( "body" ).on("change",".drawer-add-to-your-order-underscrub .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");

    var select = ".drawer-add-to-your-order-underscrub .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit-underscrub").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-underscrub .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
                //$("#drawer-cart-submit").prop("disabled", true).addClass("Button--disabled").text("Select a Size");                                                  
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-underscrub .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
          //$("#drawer-cart-submit").prop("disabled", false).removeClass("Button--disabled").text("Add to Bag");                                                  
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-underscrub-"+product;
    var select = ".drawer-add-to-your-order-underscrub-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });

  $( "body" ).on("click","#drawer-cart-submit-underscrub",function (event) {
  //$( "#drawer-cart-submit" ).click(function(event) {
  		//event.preventDefault();
    	var product = '';
        $(".drawer-add-to-your-order-underscrub .ColorSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		product = $(this).attr("data-product");
          }          
  		}); 
    	var size = '';
        $(".drawer-add-to-your-order-underscrub .SizeSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		size = $(this).val();
          }              
  		}); 
    	var variant = '';
        $(".drawer-cart-submit-underscrub").each(function(){
          if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
    		variant = $(this).attr("data-variant");
          }          
  		}); 
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: variant,
                properties: { "_bundle": true }
            },
          async: false
        });        
    	//window.location = '/checkout';
        //window.location = '/cart';
  }); 
  
  $( '#sidebar-cart' ).on("click","#drawer-cart-submit-dummy-underscrub",function (event) {
  	event.preventDefault();
    $(this).hide();
    $("#drawer-cart-underscrub-sizes").show();
    $('#sidebar-cart .Drawer__Main').animate({scrollTop: $("#drawer-cart-underscrub-sizes").offset().top},'fast');
  });  

  $( "body" ).on("change","#slider-cloveys .drawer-add-to-your-order-underscrub .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-underscrub").trigger("click");
  });  

  /* ANKLE SOCKS MODULE */
  $( "body" ).on("change",".drawer-add-to-your-order-ankle .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");

    var select = ".drawer-add-to-your-order-ankle .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-ankle .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
                //$("#drawer-cart-submit").prop("disabled", true).addClass("Button--disabled").text("Select a Size");                                                  
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-ankle .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
          //$("#drawer-cart-submit").prop("disabled", false).removeClass("Button--disabled").text("Add to Bag");                                                  
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-ankle-"+product;
    var select = ".drawer-add-to-your-order-ankle-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });

  $( "body" ).on("click","#drawer-cart-submit-ankle",function (event) {
  //$( "#drawer-cart-submit" ).click(function(event) {
  		//event.preventDefault();
    	var product = '';
        $(".drawer-add-to-your-order-ankle .ColorSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		product = $(this).attr("data-product");
          }          
  		}); 
    	var size = '';
        $(".drawer-add-to-your-order-ankle .SizeSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		size = $(this).val();
          }              
  		}); 
    	var variant = '';
        $(".drawer-cart-submit-ankle").each(function(){
          if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
    		variant = $(this).attr("data-variant");
          }          
  		}); 
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: variant,
                properties: { "_bundle": true }
            },
          async: false
        });        
    	//window.location = '/checkout';
        //window.location = '/cart';
  }); 
  
  $( '#sidebar-cart' ).on("click","#drawer-cart-submit-dummy-ankle",function (event) {
  	event.preventDefault();
    $(this).hide();
    $("#drawer-cart-ankle-sizes").show();
    /*$('#sidebar-cart .Drawer__Main').animate({scrollTop: $("#drawer-cart-ankle-sizes").offset().top},'fast');*/
  });  
  $( "body" ).on("change",".drawer-add-to-your-order-ankle .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-ankle").trigger("click");
  });    

  /* CLOVEYS */
  $( "body" ).on("change",".drawer-add-to-your-order-clovey .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");

    var select = ".drawer-add-to-your-order-clovey .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-clovey .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
                //$("#drawer-cart-submit").prop("disabled", true).addClass("Button--disabled").text("Select a Size");                                                  
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-clovey .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
          //$("#drawer-cart-submit").prop("disabled", false).removeClass("Button--disabled").text("Add to Bag");                                                  
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-clovey-"+product;
    var select = ".drawer-add-to-your-order-clovey-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });

  $( "body" ).on("click","#drawer-cart-submit-clovey",function (event) {
  //$( "#drawer-cart-submit" ).click(function(event) {
  		//event.preventDefault();
    	var product = '';
        $(".drawer-add-to-your-order-clovey .ColorSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		product = $(this).attr("data-product");
          }          
  		}); 
    	var size = '';
        $(".drawer-add-to-your-order-clovey .SizeSwatch__Radio").each(function(){
          if($(this).prop("checked")){
    		size = $(this).val();
          }              
  		}); 
    	var variant = '';
        $(".drawer-cart-submit-clovey").each(function(){
          if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
    		variant = $(this).attr("data-variant");
          }          
  		}); 
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
                quantity: 1,
                id: variant
            },
          async: false
        });        
    	//window.location = '/checkout';
        //window.location = '/cart';
  }); 
  
  $( '#sidebar-cart' ).on("click","#drawer-cart-submit-dummy-clovey",function (event) {
  	event.preventDefault();
    $(this).hide();
    $("#drawer-cart-clovey-sizes").show();
    /*$('#sidebar-cart .Drawer__Main').animate({scrollTop: $("#drawer-cart-clovey-sizes").offset().top},'fast');*/
  });  
  $( "body" ).on("change",".drawer-add-to-your-order-clovey .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-clovey").trigger("click");
  });    
  
  // MOBILE/DESKTOP IMAGE RESIZE
  $(window).resize(function() {          
      resizeImg();
  });  
  function resizeImg() { 
    
      if ($(window).width() > 640) {
        $( ".resize" ).each(function() {
          $( this ).attr("src", $( this ).attr("data-src-desktop"));          
          var image = "url("+$( this ).attr("data-src-desktop")+")";
        });            
      } else {
        $( ".resize" ).each(function() {
          $( this ).attr("src", $( this ).attr("data-src-mobile"));          
          var image = "url("+$( this ).attr("data-src-mobile")+")";
        });      
      } 
  }
  /*
  $( document ).ready(function() {        
      resizeImg();
  });
  */
  $( window ).on( "load", function() {
      resizeImg();
  });
  
  // HOMEPAGE TICKER
  $("#webTicker").webTicker({
      height:'70px',
      duplicate:true, 
      startEmpty:false,
      hoverpause:false 
  });
  
  // LOGO VIDEO
/*
  window.addEventListener('scroll', function() {
      var element = document.querySelector("#logo-video");
      var position = element.getBoundingClientRect();

      if(position.top >= 0) {
         $("#logo-video").play();
      }
  }); 
  // PDP VIDEO
  $(".template-product .video").each(function() {
      this.play();

  }); 
  */

  // VIDEOS
  /*
  $('.video').each( function(){ 
    if($(this).hasClass("played")){
    } else {
      if (checkVisible($(this))) {
          this.play();
          $(this).addClass("played");
      }
    }
  }); 
  window.addEventListener('scroll', function(){
    $('.video').each( function(){ 
      if($(this).hasClass("played")){
      } else {
        if (checkVisible($(this))) {
        	this.play();
          	$(this).addClass("played");
        }
      }
    }); 
  });
  */
  /*
  $(document.body).click( function() {
    $('.video').each( function(){ 
      if($(this).hasClass("played")){
      } else {
        if (checkVisible($(this))) {
        	this.play();
          	$(this).addClass("played");
        }
      }
    }); 
  });
  */


  
});




// 2019 PRESTIGE THEME FIX
(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

  // QUICK ADD 
  
  function loadQuickAdd(){
    $(".quickadd-slider").each(function() {
      if($(this).hasClass("loaded")){
      } else {
        $(this).flickity({
          contain: true,
          cellAlign: 'center',

          /*
          groupCells: true,

          freeScroll: true,

          cellAlign: 'left',
          */
          prevNextButtons: true,
          pageDots: false
        });
        $(this).addClass("loaded");
      }
    });
  }  

  
 function updateButton(){
   
      var sex = $("#quickadd .sex-selected .sex-text").attr("data-sex");
      var style = $("#quickadd-shoes-slider .quickadd-style.active .product-selected").attr("data-style");
      var color = $("#quickadd-shoes-slider .quickadd-style.active .product-selected").attr("data-color");
      var product = $("#quickadd-shoes-slider .quickadd-style.active .product-selected").attr("data-product");
      var size = $("#quickadd-size-slider .active input:checked").val();
      var stock = '';
      var shoeprice = '';

      // SCROLL TO SELECTED PRODUCT
      var index = $("#quickadd-shoes-slider .active .product-selected").index();
      $("#quickadd-shoes-slider .quickadd-slider.active").flickity( 'select', index );

      // CHECK SOLD OUT SIZES
      $("#quickadd-select > option").each(function() {
        if($(this).attr("data-product-id") == product){
          var thissize = $(this).attr("data-size");
          var thisstock = $(this).attr("data-stock");

          $("#quickadd-size-slider .active input").each(function() {
            if($(this).val() == thissize){
              if(thisstock == 'instock' || thisstock == 'preorder'){
                $(this).parent().removeClass("soldout");
              } else {
                $(this).parent().addClass("soldout");
              }
            }
          });
        }   
      });

      if(size){

        // CHECK SOLD OUT PRODUCTS
        $("#quickadd-select > option").each(function() {
          if($(this).attr("data-size") == size){
            var thisproduct = $(this).attr("data-product-id");
            var thisstock = $(this).attr("data-stock");
            $("#quickadd-shoes-slider .active .quickadd-product").each(function() {
              if($(this).attr("data-product") == thisproduct){
                if(thisstock == 'instock' || thisstock == 'preorder'){
                  $(this).removeClass("soldout");
                } else {
                  $(this).addClass("soldout");
                }
              }
            });
          }   
        });
        
        // GET PRICE OF SELECTED PRODUCT
        $("#quickadd-select > option").each(function() {
          if($(this).attr("data-product-id") == product){
            if($(this).attr("data-size") == size){
              value = $(this).val();
              shoeprice = $(this).attr("data-price");
              stock = $(this).attr("data-stock");
              $("#quickadd-select").val(value);
              $("#quickadd-select").trigger("change")
            }
          }   
        });
        
        if(stock == "instock" || stock == "preorder" ){

          // ADD UP PRICE OF SELECTED CLOVEY'S
          var cloveyprice = 0;
          $("#quickadd-cloveys-slider input:checked").each(function() {
              cloveyprice = cloveyprice + parseInt($(this).attr("data-price"));
          });
          
          // UPDATE BUTTON
          if(stock == "preorder"){
            //buttonwords = 'Pre-order';
            buttonwords = 'Add to Cart';
          } else {
            buttonwords = 'Add to Cart';
          }
          var totalprice = parseInt(shoeprice) + parseInt(cloveyprice);
          totalprice = totalprice/100;
          //var buttontext = '<span>'+buttonwords+'</span><span class="Button__SeparatorDot"></span><span data-money-convertible>$'+totalprice+'</span>'
          $("#quickadd .ProductForm__AddToCart").prop("disabled",false);
          //$("#quickadd .ProductForm__AddToCart").html(buttontext);

          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-text").html(buttonwords);
          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-price-price").html(totalprice);

          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-select-a-size").hide();
          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-price").show();
        } else {
          
          $("#quickadd .ProductForm__AddToCart").prop("disabled",true);
          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-select-a-size").html("Sold Out");
          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-select-a-size").show();
          $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-price").hide();
        }  
        
      } else {
        
        $("#quickadd .ProductForm__AddToCart").prop("disabled",true);
        $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-select-a-size").html("Select a Size");
        $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-select-a-size").show();
        $("#quickadd .ProductForm__AddToCart .quickadd-addtocart-price").hide();

        // SCROLL TO MIDDLE 
        if(sex == 'mens'){
          $("#quickadd-size-slider .active").flickity('select', 6);
        } else {
          $("#quickadd-size-slider .active").flickity('select', 6);

        }
        
      }
   
  }
  function quickAddSelect(sex){
    if(sex == 'mens'){
      $("#quickadd .sex-selector .sex-toggle:nth-of-type(2)").removeClass("sex-unselected");
      $("#quickadd .sex-selector .sex-toggle:nth-of-type(2)").addClass("sex-selected");
      $("#quickadd .sex-selector .sex-toggle:first-of-type").removeClass("sex-selected");
      $("#quickadd .sex-selector .sex-toggle:first-of-type").addClass("sex-unselected");
      $("#quickadd .quickadd-mens").addClass("active");
      $("#quickadd .quickadd-womens").removeClass("active");
    } else {
      $("#quickadd .sex-selector .sex-toggle:first-of-type").removeClass("sex-unselected");
      $("#quickadd .sex-selector .sex-toggle:first-of-type").addClass("sex-selected");
      $("#quickadd .sex-selector .sex-toggle:nth-of-type(2)").removeClass("sex-selected");
      $("#quickadd .sex-selector .sex-toggle:nth-of-type(2)").addClass("sex-unselected");
      $("#quickadd .quickadd-mens").removeClass("active");
      $("#quickadd .quickadd-womens").addClass("active");
    }

    // SELECT COLOR
    color = $(".product-selected").attr("data-color");
    style = $(".product-selected").attr("data-style");

    $(".quickadd-"+style+" .quickadd-"+sex+" .quickadd-product").each(function() {
      if($(this).attr("data-color") == color){
        $(this).trigger("click");
      } else {
        $(this).removeClass("product-selected");
      }
    });

    // RESET SIZE or HANDLE SOLD OUT
    
    $(".quickadd-slider").each(function() {
      $(this).flickity("resize");
    }); 
  }

  function updateColor(color){
    $("#quickadd-color").html(color);
  }

  
//$(".ProductItem-quickadd-button").click(function() {  
  $("#main").on( "click", ".ProductItem-quickadd-button", function() {

    $(".PageContainer").addClass("quickadd-open");
    $("#quickadd").slideDown();
    $(".quickadd-slider").each(function() {
      $(this).flickity("resize");
    });

    var style = $(this).attr("data-style");
    var sex = $(this).attr("data-sex");
    var productid = $(this).attr("data-product");
    var color = $(this).attr("data-color");

    // UPDATE COLOR
    updateColor(color);

    // SELECT PRODUCT
    $(".quickadd-product").each(function() {
      if($(this).attr("data-product") == productid){
        $(this).trigger("click");
      } else {
        $(this).removeClass("product-selected");
      }
    });
    
    // SHOW STYLE
    if(style == 'aeros'){
      $("#quickadd .quickadd-aeros").addClass("active");
      $("#quickadd .quickadd-classic").removeClass("active")
      $("#quickadd .quickadd-solo").removeClass("active")
      $("#quickadd .quickadd-forte").removeClass("active")
      $("#quickadd .quickadd-alto").removeClass("active")
      $("#quickadd .quickadd-superboot").removeClass("active")
    } else if(style == 'solo') {
      $("#quickadd .quickadd-aeros").removeClass("active")
      $("#quickadd .quickadd-classic").removeClass("active")
      $("#quickadd .quickadd-solo").addClass("active")
      $("#quickadd .quickadd-forte").removeClass("active")
      $("#quickadd .quickadd-alto").removeClass("active")
      $("#quickadd .quickadd-superboot").removeClass("active")
    } else if(style == 'forte') {
      $("#quickadd .quickadd-aeros").removeClass("active")
      $("#quickadd .quickadd-classic").removeClass("active")
      $("#quickadd .quickadd-solo").removeClass("active")
      $("#quickadd .quickadd-forte").addClass("active")
      $("#quickadd .quickadd-alto").removeClass("active")
      $("#quickadd .quickadd-superboot").removeClass("active")
    } else if(style == 'alto') {
      $("#quickadd .quickadd-aeros").removeClass("active")
      $("#quickadd .quickadd-classic").removeClass("active")
      $("#quickadd .quickadd-solo").removeClass("active")
      $("#quickadd .quickadd-forte").removeClass("active")
      $("#quickadd .quickadd-alto").addClass("active")
      $("#quickadd .quickadd-superboot").removeClass("active")
    } else if(style == 'superboot') {
      $("#quickadd .quickadd-aeros").removeClass("active")
      $("#quickadd .quickadd-classic").removeClass("active")
      $("#quickadd .quickadd-solo").removeClass("active")
      $("#quickadd .quickadd-forte").removeClass("active")
      $("#quickadd .quickadd-alto").removeClass("active")
      $("#quickadd .quickadd-superboot").addClass("active")
    } else {
      $("#quickadd .quickadd-aeros").removeClass("active")
      $("#quickadd .quickadd-classic").addClass("active")
      $("#quickadd .quickadd-solo").removeClass("active")
      $("#quickadd .quickadd-forte").removeClass("active")
      $("#quickadd .quickadd-alto").removeClass("active")
      $("#quickadd .quickadd-superboot").removeClass("active")
    }
    
    // SELECT / SEX
    quickAddSelect(sex);
    updateButton();

  });

  $("#quickadd .sex-toggle").click(function() { 
    var sex = $(this).find(".sex-text").attr("data-sex");
    quickAddSelect(sex);
    updateButton();

  });

  $(".quickadd-product").click(function() {  
    $(".quickadd-product").each(function() {
      $(this).removeClass("product-selected");
    });

    $(this).addClass("product-selected");
    var index = $(this).index();
    $("#quickadd-shoes-slider .quickadd-slider").flickity( 'select', index );
    
    // UPDATE COLOR
    var color = $(this).attr("data-color");
    updateColor(color);
    updateButton();

  });
  /*

  $(".quickadd-product .carousel-cell-content").click(function() {  
    $(".quickadd-product").each(function() {
      $(this).removeClass("product-selected");
    });

    $(this).parent().parent().addClass("product-selected");
    var index = $(this).parent().parent().index();
    $("#quickadd-shoes-slider .quickadd-slider").flickity( 'select', index );
    
    // UPDATE COLOR
    var color = $(this).parent().parent().attr("data-color");
    updateColor(color);
    updateButton();

  });
  */

  
  $( "#quickadd-size-slider" ).on("change",".active .SizeSwatch__Radio",function () {
    updateButton();
  }); 
  
  $( "#quickadd-cloveys-slider" ).on("change",".ColorSwatch__Radio",function () {
    updateButton();
  }); 

  function closeQuickAdd(){
    $(".PageContainer").removeClass("quickadd-open");
    $("#quickadd").slideUp();
  }
  $("#quickadd-close").click(function() {  
    closeQuickAdd();
  });
  $(document).on('keydown', function(event) {
    if (event.key == "Escape") {
      closeQuickAdd();
    }
  });

  $( document ).ready(function() {  
    loadQuickAdd();

    $("#quickadd-shoes-slider .Carousel").on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
      if (typeof cellIndex == 'number'){
        $(this).flickity( 'select', cellIndex );
      }
    });
    $("#quickadd-size-slider .Carousel").on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
      if (typeof cellIndex == 'number'){
        $(this).flickity( 'select', cellIndex );
      }
    });
  });


  // ADD TO CART
  //$("#quickadd").submit(function(e) {
  $(document).on('click','.quickadd-addtocart-button',function(e){
    var variant = $("#quickadd-select").val();
    e.preventDefault();
    var button = this;

    var Preorder = '';
    var FINALSALE = '';
    var final = ''
    var stock = '';
    $("#quickadd-select > option").each(function() {
      if($(this).val() == variant){
        stock = $(this).attr("data-stock");
        if(stock == 'preorder'){
          var shippingdate = $(this).attr("data-preorder-date");
          Preorder = "Estimated Shipping Date: "+shippingdate;            
        }
        final = $(this).attr("data-finalsale");
        if(final == 'y'){
          FINALSALE = "NO RETURNS/EXCHANGES"            
        }
      }   
    });

    if(Preorder == '' && FINALSALE == ''){
      // ADD SHOE TO CART
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant
        },
        dataType: 'json',
        success: function (data){
          document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
          closeQuickAdd();
          
          $("#quickadd-cloveys-slider input:checked").each(function() {
            var variantid = $(this).val();
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: variantid
                },
              async: false
            });        
            setTimeout(function() {
                document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
  
            }, 200);
          }); 
        },
        error: function () {
        }
      });
    } else if(Preorder == '' && FINALSALE != ''){
      // ADD SHOE TO CART (duplicate from above)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant,
          properties: {
            FINALSALE
          }
        },
        dataType: 'json',
        success: function (data){
          document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
          closeQuickAdd();
          
          $("#quickadd-cloveys-slider input:checked").each(function() {
            var variantid = $(this).val();
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: variantid
                },
              async: false
            });        
            setTimeout(function() {
                document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
  
            }, 200);
          }); 
        },
        error: function () {
        }
      });    
    } else if(Preorder != '' && FINALSALE == ''){
      // ADD SHOE TO CART (duplicate from above)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant,
          properties: {
            Preorder
          }
        },
        dataType: 'json',
        success: function (data){
          document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
          closeQuickAdd();
          
          $("#quickadd-cloveys-slider input:checked").each(function() {
            var variantid = $(this).val();
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: variantid
                },
              async: false
            });        
            setTimeout(function() {
                document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
  
            }, 200);
          }); 
        },
        error: function () {
        }
      });
    } else {
      // ADD SHOE TO CART (duplicate from above)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant,
          properties: {
            Preorder,
            FINALSALE
          }
        },
        dataType: 'json',
        success: function (data){
          document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
          closeQuickAdd();
          
          $("#quickadd-cloveys-slider input:checked").each(function() {
            var variantid = $(this).val();
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    quantity: 1,
                    id: variantid
                },
              async: false
            });        
            setTimeout(function() {
                document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
  
            }, 200);
          }); 
        },
        error: function () {
        }
      });
    }
  });  


// BUNDLE DRAWER MODULE

  // CHANGE ADD TO CART BUTTON STATES
  /*
    $( "#sidebar-cart" ).on("change","input",function () {
      setTimeout(() => {
        var checked = 0;
        var select = ".drawer-add-to-your-order input";
        $(select).each(function() {
          if($(this).is(':checked')){
            checked++;
          }
        });       
        var select = ".drawer-add-to-your-order-underscrub input";
        $(select).each(function() {
          if($(this).is(':checked')){
            checked++;
          }
        }); 
        var needtobechecked = 0;
        if($(".drawer-add-to-your-order").length && $(".drawer-add-to-your-order-underscrub").length ){
          needtobechecked = 4;
        } else {
          needtobechecked = 2;
        }
        if(checked == needtobechecked){
          $("#drawer-cart-submit-bundle-submit").removeClass("Button--disabled").prop("disabled", false).html("Add Items");
        } else {
          $("#drawer-cart-submit-bundle-submit").addClass("Button--disabled").prop("disabled", true).html("Select Colors and Sizes");
        }
      }, 100);
    }); 
  */
  // ADD TO CART FUNCTION
    $( "#sidebar-cart" ).on("click","#drawer-cart-submit-bundle-submit",function (event) {
         if($(".drawer-add-to-your-order-underscrub").length ){

          var product = '';
          $(".drawer-add-to-your-order-underscrub .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order-underscrub .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant1 = '';
          $(".drawer-cart-submit-underscrub").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant1 = $(this).attr("data-variant");
            }          
          }); 
        }
      
        if($(".drawer-add-to-your-order").length){
          var product = '';
          $(".drawer-add-to-your-order .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant2 = '';
          $(".drawer-cart-submit").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant2 = $(this).attr("data-variant");
            }          
          }); 
        }

        if(variant1 && variant2 ){
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {items: [{quantity: 1,id: variant1},{quantity: 1,id: variant2,properties: { "_bundle": true }}]},async: false
          });    
        } else if (variant2) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant2,properties: { "_bundle": true }},async: false
          });    
        } else if (variant1) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant1,properties: { "_bundle": true }},async: false
          });    
        }
      
    }); 


// MULTI-BUNDLE DRAWER MODULE
  $( document ).ready(function() {  
    $( "#sidebar-cart").on( "click",".drawer-bundles-header", function(event) {
      if(event.target.className == 'drawer-bundles-header-info' || event.target.id == 'drawer-bundles-header-info'){
        event.preventDefault();
      } else {
        $(this).parent().toggleClass("expanded");
        if($(this).parent().attr("aria-expanded") == true){
          $(this).parent().attr("aria-expanded", false);
        } else{
          $(this).parent().attr("aria-expanded", true);
        }
        $(".drawer-bundles-content").slideToggle("slow", function() {
          // SHOULD SCROLL DOWN A LITTLE HERE?
          //$("#sidebar-cart .Drawer__Main").scrollTop($("#sidebar-cart .Drawer__Main")[0].scrollHeight);
        });  
      }
    });
    $( "#sidebar-cart").on( "click",".drawer-bundles-bundle-toggle" , function() {
      $(this).toggleClass("expanded");
      if($(this).attr("aria-expanded") == true){
        $(this).attr("aria-expanded", false);
      } else{
        $(this).attr("aria-expanded", true);
      }
      $(this).parent().next().slideToggle("slow", function() {
        // SHOULD SCROLL DOWN A LITTLE HERE?
        //$("#sidebar-cart .Drawer__Main").scrollTop($("#sidebar-cart .Drawer__Main")[0].scrollHeight);
      });  
    });  
    $( "#sidebar-cart").on( "click",".drawer-bundles-bundle-header" , function() {
      $(this).next().toggleClass("expanded");
      if($(this).next().attr("aria-expanded") == true){
        $(this).next().attr("aria-expanded", false);
      } else{
        $(this).next().attr("aria-expanded", true);
      }
      $(this).parent().next().slideToggle("slow", function() {
        // SHOULD SCROLL DOWN A LITTLE HERE?
        //$("#sidebar-cart .Drawer__Main").scrollTop($("#sidebar-cart .Drawer__Main")[0].scrollHeight);
      });  
    }); 
  });  
  
  /* CLASSIC */
    
    // CHANGE ADD TO CART BUTTON STATES
    /*
      $( "#sidebar-cart" ).on("change","input",function () {
        setTimeout(() => {
          var checked = 0;
          var select = ".drawer-add-to-your-order-classic-socks input";
          $(select).each(function() {
            if($(this).is(':checked')){
              checked++;
            }
          });       
          var select = ".drawer-add-to-your-order-classic-underscrub input";
          $(select).each(function() {
            if($(this).is(':checked')){
              checked++;
            }
          }); 
          var needtobechecked = 0;
          if($(".drawer-add-to-your-order-classic-socks").length && $(".drawer-add-to-your-order-classic-underscrub").length ){
            needtobechecked = 4;
          } else {
            needtobechecked = 2;
          }
          if(checked == needtobechecked){
            $("#drawer-cart-submit-bundle-classic").removeClass("Button--disabled").prop("disabled", false).html("Add Items");
          } else {
            $("#drawer-cart-submit-bundle-classic").addClass("Button--disabled").prop("disabled", true).html("Select Colors and Sizes");
          }
        }, 100);
      }); 
    */  
    // ADD TO CART FUNCTION
      $( "#sidebar-cart" ).on("click","#drawer-cart-submit-bundle-classic",function (event) {
           if($(".drawer-add-to-your-order-classic-underscrub").length ){
    
            var product = '';
            $(".drawer-add-to-your-order-classic-underscrub .ColorSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                product = $(this).attr("data-product");
              }          
            }); 
            var size = '';
            $(".drawer-add-to-your-order-classic-underscrub .SizeSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                size = $(this).val();
              }              
            }); 
            var variant1 = '';
            $(".drawer-cart-submit-classic-underscrub").each(function(){
              if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
                variant1 = $(this).attr("data-variant");
              }          
            }); 
          }
        
          if($(".drawer-add-to-your-order-classic-socks").length){
            var product = '';
            $(".drawer-add-to-your-order-classic-socks .ColorSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                product = $(this).attr("data-product");
              }          
            }); 
            var size = '';
            $(".drawer-add-to-your-order-classic-socks .SizeSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                size = $(this).val();
              }              
            }); 
            var variant2 = '';
            $(".drawer-cart-submit-classic-socks").each(function(){
              if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
                variant2 = $(this).attr("data-variant");
              }          
            }); 
          }
    
          if(variant1 && variant2 ){
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {items: [{quantity: 1,id: variant1,properties: { "_bundle": true }},{quantity: 1,id: variant2,properties: { "_bundle": true }}]},async: false
            });    
          } else if (variant2) {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {quantity: 1,id: variant2,properties: { "_bundle": true }},async: false
            });    
          } else if (variant1) {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {quantity: 1,id: variant1,properties: { "_bundle": true }},async: false
            });    
          }
        
      }); 

    /* BUNDLE SWATCH FUNCTIONALITY */

      /* UNDERSCRUB MODULE */
      $( "#sidebar-cart" ).on("change",".drawer-add-to-your-order-classic-underscrub .ColorSwatch__Radio",function () {
        var product = $(this).attr("data-product");
      
        var select = $(".drawer-add-to-your-order-classic-underscrub .ColorSwatch__Radio");
        $(select).each(function() {
          if($(this).attr("data-product") == product){
          } else {
            $(this).prop("checked",false);
          }
        });
        
        // CHANGE SIZE SELECTOR TO SOLD OUT
        $(".drawer-cart-submit-classic-underscrub").each(function(){
          if($(this).attr("data-product") == product){
            var size = $(this).attr("data-size");
            if($(this).attr("data-inventory") < 1){
              $(".drawer-add-to-your-order-classic-underscrub .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().addClass("soldout");
                  $(this).prop("disabled", true);
                  if($(this).prop("checked")){
                    $(this).prop("checked", false);
                  }
                }              
              }); 
            } else {
              $(".drawer-add-to-your-order-classic-underscrub .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().removeClass("soldout");
                  $(this).prop("disabled", false);
                }              
              }); 
            }
          }          
        }); 
        
        var hasclass = "drawer-add-to-your-order-classic-underscrub-"+product;
        var select = ".drawer-add-to-your-order-classic-underscrub-product";
        $(select).each(function() {
          if($(this).hasClass(hasclass)){
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
      });

      /* CLASSIC - SOCK MODULE */
      $( "#sidebar-cart" ).on("change",".drawer-add-to-your-order-classic-socks .ColorSwatch__Radio",function () {
        var product = $(this).attr("data-product");
      
        var select = $(".drawer-add-to-your-order-classic-socks .ColorSwatch__Radio");
        $(select).each(function() {
          if($(this).attr("data-product") == product){
          } else {
            $(this).prop("checked",false);
          }
        });
        
        // CHANGE SIZE SELECTOR TO SOLD OUT
        $(".drawer-cart-submit-classic-socks").each(function(){
          if($(this).attr("data-product") == product){
            var size = $(this).attr("data-size");
            if($(this).attr("data-inventory") < 1){
              $(".drawer-add-to-your-order-classic-socks .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().addClass("soldout");
                  $(this).prop("disabled", true);
                  if($(this).prop("checked")){
                    $(this).prop("checked", false);
                  }
                }              
              }); 
            } else {
              $(".drawer-add-to-your-order-classic-socks .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().removeClass("soldout");
                  $(this).prop("disabled", false);
                }              
              }); 
            }
          }          
        }); 
        
        var hasclass = "drawer-add-to-your-order-classic-socks-"+product;
        var select = ".drawer-add-to-your-order-classic-socks-product";
        $(select).each(function() {
          if($(this).hasClass(hasclass)){
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
      });

/* SOCKS */

    // CHANGE ADD TO CART BUTTON STATES
    /*
      $( "#sidebar-cart" ).on("change","input",function () {
        setTimeout(() => {
          var checked = 0;
          var select = ".drawer-add-to-your-order-socks-socks-1 input";
          $(select).each(function() {
            if($(this).is(':checked')){
              checked++;
            }
          });       
          var select = ".drawer-add-to-your-order-socks-socks-2 input";
          $(select).each(function() {
            if($(this).is(':checked')){
              checked++;
            }
          }); 
          var needtobechecked = 0;
          
          if($(".drawer-add-to-your-order-socks-socks-1").length && $(".drawer-add-to-your-order-socks-socks-2").length ){
            needtobechecked = 4;
          } else {
            needtobechecked = 2;
          }

          if(checked == needtobechecked){
            $("#drawer-cart-submit-bundle-socks").removeClass("Button--disabled").prop("disabled", false).html("Add Items");
          } else {
            $("#drawer-cart-submit-bundle-socks").addClass("Button--disabled").prop("disabled", true).html("Select Colors and Sizes");
          }
        }, 100);
      }); 
    */
    // ADD TO CART FUNCTION
      $( "#sidebar-cart" ).on("click","#drawer-cart-submit-bundle-socks",function (event) {
           if($(".drawer-add-to-your-order-socks-socks-2").length ){
    
            var product = '';
            $(".drawer-add-to-your-order-socks-socks-2 .ColorSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                product = $(this).attr("data-product");
              }          
            }); 
            var size = '';
            $(".drawer-add-to-your-order-socks-socks-2 .SizeSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                size = $(this).val();
              }              
            }); 
            var variant1 = '';
            $(".drawer-cart-submit-socks-socks-2").each(function(){
              if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
                variant1 = $(this).attr("data-variant");
              }          
            }); 
          }
        
          if($(".drawer-add-to-your-order-socks-socks-1").length){
            var product = '';
            $(".drawer-add-to-your-order-socks-socks-1 .ColorSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                product = $(this).attr("data-product");
              }          
            }); 
            var size = '';
            $(".drawer-add-to-your-order-socks-socks-1 .SizeSwatch__Radio").each(function(){
              if($(this).prop("checked")){
                size = $(this).val();
              }              
            }); 
            var variant2 = '';
            $(".drawer-cart-submit-socks-socks-1").each(function(){
              if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
                variant2 = $(this).attr("data-variant");
              }          
            }); 
          }
    
          if($(".drawer-add-to-your-order-socks-socks-1").length && $(".drawer-add-to-your-order-socks-socks-2").length ){
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {items: [{quantity: 1,id: variant1,properties: { "_bundle": true }},{quantity: 1,id: variant2,properties: { "_bundle": true }}]},async: false
            });    
          } else if ($(".drawer-add-to-your-order-socks-socks-1").length) {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {quantity: 1,id: variant2,properties: { "_bundle": true }},async: false
            });    
          } else if ($(".drawer-add-to-your-order-socks-socks-2").length) {
            jQuery.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {quantity: 1,id: variant1,properties: { "_bundle": true }},async: false
            });    
          }
        
      }); 

      /* SOCKS - SOCK MODULE 1 */
      $( "#sidebar-cart" ).on("change",".drawer-add-to-your-order-socks-socks-1 .ColorSwatch__Radio",function () {
        var product = $(this).attr("data-product");
      
        var select = $(".drawer-add-to-your-order-socks-socks-1 .ColorSwatch__Radio");
        $(select).each(function() {
          if($(this).attr("data-product") == product){
          } else {
            $(this).prop("checked",false);
          }
        });
        
        // CHANGE SIZE SELECTOR TO SOLD OUT
        $(".drawer-cart-submit-socks-socks-1").each(function(){
          if($(this).attr("data-product") == product){
            var size = $(this).attr("data-size");
            if($(this).attr("data-inventory") < 1){
              $(".drawer-add-to-your-order-socks-socks-1 .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().addClass("soldout");
                  $(this).prop("disabled", true);
                  if($(this).prop("checked")){
                    $(this).prop("checked", false);
                  }
                }              
              }); 
            } else {
              $(".drawer-add-to-your-order-socks-socks-1 .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().removeClass("soldout");
                  $(this).prop("disabled", false);
                }              
              }); 
            }
          }          
        }); 
        
        var hasclass = "drawer-add-to-your-order-socks-socks-1-"+product;
        var select = ".drawer-add-to-your-order-socks-socks-1-product";
        $(select).each(function() {
          if($(this).hasClass(hasclass)){
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
      });

      /* SOCKS - SOCK MODULE 2 */
      $( "#sidebar-cart" ).on("change",".drawer-add-to-your-order-socks-socks-2 .ColorSwatch__Radio",function () {
        var product = $(this).attr("data-product");
      
        var select = $(".drawer-add-to-your-order-socks-socks-2 .ColorSwatch__Radio");
        $(select).each(function() {
          if($(this).attr("data-product") == product){
          } else {
            $(this).prop("checked",false);
          }
        });
        
        // CHANGE SIZE SELECTOR TO SOLD OUT
        $(".drawer-cart-submit-socks-socks-2").each(function(){
          if($(this).attr("data-product") == product){
            var size = $(this).attr("data-size");
            if($(this).attr("data-inventory") < 1){
              $(".drawer-add-to-your-order-socks-socks-2 .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().addClass("soldout");
                  $(this).prop("disabled", true);
                  if($(this).prop("checked")){
                    $(this).prop("checked", false);
                  }
                }              
              }); 
            } else {
              $(".drawer-add-to-your-order-socks-socks-2 .SizeSwatch__Radio").each(function(){
                if($(this).val() == size){
                  $(this).parent().removeClass("soldout");
                  $(this).prop("disabled", false);
                }              
              }); 
            }
          }          
        }); 
        
        var hasclass = "drawer-add-to-your-order-socks-socks-2-"+product;
        var select = ".drawer-add-to-your-order-socks-socks-2-product";
        $(select).each(function() {
          if($(this).hasClass(hasclass)){
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
      });


// SOCKS ONLY BUNDLE MODULE

  // SWATCHES
  $( "body" ).on("change",".drawer-add-to-your-order-socks .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");
    var select = ".drawer-add-to-your-order-socks .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit-socks-one").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-socks .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-socks .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-socks-"+product;
    var select = ".drawer-add-to-your-order-socks-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });  
  // SWATCHES
  $( "body" ).on("change",".drawer-add-to-your-order-socks-two .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");
    var select = ".drawer-add-to-your-order-socks-two .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit-socks-two").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-socks-two .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-socks-two .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-socks-two-"+product;
    var select = ".drawer-add-to-your-order-socks-two-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });  
  
  // CHANGE ADD TO CART BUTTON STATES
    /*
    $( "#sidebar-cart" ).on("change","input",function () {
      setTimeout(() => {
        var checked = 0;
        var select = ".drawer-add-to-your-order-socks input";
        $(select).each(function() {
          if($(this).is(':checked')){
            checked++;
          }
        });       
        var select = ".drawer-add-to-your-order-socks-two input";
        $(select).each(function() {
          if($(this).is(':checked')){
            checked++;
          }
        }); 
        var needtobechecked = 0;
        if($(".drawer-add-to-your-order-socks").length && $(".drawer-add-to-your-order-socks-two").length ){
          needtobechecked = 4;
        } else {
          needtobechecked = 2;
        }
        if(checked == needtobechecked){
          $("#drawer-cart-submit-bundle-socks-submit").removeClass("Button--disabled").prop("disabled", false).html("Add Items");
        } else {
          $("#drawer-cart-submit-bundle-socks-submit").addClass("Button--disabled").prop("disabled", true).html("Select Colors and Sizes");
        }
      }, 100);
    }); 
    */
  // ADD TO CART FUNCTION
    $( "#sidebar-cart" ).on("click","#drawer-cart-submit-bundle-socks-submit",function (event) {
         if($(".drawer-add-to-your-order-socks-two").length ){

          var product = '';
          $(".drawer-add-to-your-order-socks-two .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order-socks-two .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant1 = '';
          $(".drawer-cart-submit-socks-two").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant1 = $(this).attr("data-variant");
            }          
          }); 
        }
      
        if($(".drawer-add-to-your-order-socks").length){
          var product = '';
          $(".drawer-add-to-your-order-socks .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order-socks .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant2 = '';
          $(".drawer-cart-submit-socks-one").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant2 = $(this).attr("data-variant");
            }          
          }); 
        }

        if(variant1 && variant2 ){
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {items: [{quantity: 1,id: variant1,properties: { "_gwp": true }},{quantity: 1,id: variant2,properties: { "_gwp": true }}]},async: false
          });    
        } else if (variant2) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant2,properties: { "_gwp": true }},async: false
          });    
        } else if (variant1) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant1,properties: { "_gwp": true }},async: false
          });    
        }
      
    }); 

// ANKLE SOCKS BUNDLE MODULE

  // SWATCHES
  $( "body" ).on("change",".drawer-add-to-your-order-ankle-socks .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");
    var select = ".drawer-add-to-your-order-ankle-socks .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit-socks-one").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-ankle-socks .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-ankle-socks .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-ankle-socks-"+product;
    var select = ".drawer-add-to-your-order-ankle-socks-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });  
  // SWATCHES
  $( "body" ).on("change",".drawer-add-to-your-order-ankle-socks-two .ColorSwatch__Radio",function () {
    var product = $(this).attr("data-product");
    var select = ".drawer-add-to-your-order-ankle-socks-two .ColorSwatch__Radio";
  	$(select).each(function() {
      if($(this).attr("data-product") == product){
      } else {
        $(this).prop("checked",false);
      }
  	});
    
    // CHANGE SIZE SELECTOR TO SOLD OUT
    $(".drawer-cart-submit-ankle-socks-two").each(function(){
      if($(this).attr("data-product") == product){
        var size = $(this).attr("data-size");
        if($(this).attr("data-inventory") < 1){
          $(".drawer-add-to-your-order-ankle--socks-two .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().addClass("soldout");
              $(this).prop("disabled", true);
          	  if($(this).prop("checked")){
              	$(this).prop("checked", false);
              }
            }              
          }); 
        } else {
          $(".drawer-add-to-your-order-ankle-socks-two .SizeSwatch__Radio").each(function(){
            if($(this).val() == size){
              $(this).parent().removeClass("soldout");
              $(this).prop("disabled", false);
            }              
          }); 
        }
      }          
    }); 
    
    var hasclass = "drawer-add-to-your-order-ankle-socks-two-"+product;
    var select = ".drawer-add-to-your-order-ankle-socks-two-product";
  	$(select).each(function() {
      if($(this).hasClass(hasclass)){
        $(this).removeClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
  	});
  });  
  
  // ADD TO CART FUNCTION
    $( "#sidebar-cart" ).on("click","#drawer-cart-submit-bundle-ankle-submit",function (event) {
         if($(".drawer-add-to-your-order-ankle-socks-two").length ){

          var product = '';
          $(".drawer-add-to-your-order-ankle-socks-two .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order-ankle-socks-two .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant1 = '';
          $(".drawer-cart-submit-ankle-socks-two").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant1 = $(this).attr("data-variant");
            }          
          }); 
        }
      
        if($(".drawer-add-to-your-order-ankle-socks").length){
          var product = '';
          $(".drawer-add-to-your-order-ankle-socks .ColorSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              product = $(this).attr("data-product");
            }          
          }); 
          var size = '';
          $(".drawer-add-to-your-order-ankle-socks .SizeSwatch__Radio").each(function(){
            if($(this).prop("checked")){
              size = $(this).val();
            }              
          }); 
          var variant2 = '';
          $(".drawer-cart-submit-ankle-socks-one").each(function(){
            if($(this).attr("data-product") == product && $(this).attr("data-size") == size){
              variant2 = $(this).attr("data-variant");
            }          
          }); 

        }
        if(variant1 && variant2 ){
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {items: [{quantity: 1,id: variant1, properties: { "_bundle": true }},{quantity: 1,id: variant2,properties: { "_bundle": true }}]},async: false
          });    
        } else if (variant2) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant2,properties: { "_bundle": true }},async: false
          });    
        } else if (variant1) {
          jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: {quantity: 1,id: variant1,properties: { "_bundle": true }},async: false
          });    
        }
      
    }); 

  // ADD TO CART WHEN SIZE IS SELECTED  
  $( "body" ).on("change","#drawer-bundle-ankle .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-bundle-ankle-submit").trigger("click");
  });  
  
  $( "body" ).on("change","#drawer-bundle-socks .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-bundle-socks-submit").trigger("click");
  });  

  $( "body" ).on("change","#drawer-bundle .SizeSwatch__Radio",function () {
    $("#sidebar-cart").find("#drawer-cart-submit-bundle-submit").trigger("click");
  });

  // HOTJAR FIX - CHANGE MOBILE NAV HTML ON CLICK
  $( "#sidebar-menu" ).on("change","#new-nav .menu-checkbox",function () {
    if($(this).is(':checked')){
      $(this).addClass("open");
    } else {
      $(this).removeClass("open");
    }
  });

/* COUNTDOWN TIMER */
  // Set the date we're counting down to
  var countDownDate = new Date("Nov 28, 2023 00:00:00").getTime();
  
  // Update the count down every 1 second
  var x = setInterval(function() {
  
    // Get today's date and time
    var now = new Date().getTime();
  
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
  
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    hours = days * 24 + hours
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    if(seconds < 10){
      seconds = "0" + seconds
    }
    if(minutes < 10){
      minutes = "0" + minutes
    }  
    if(hours < 10){
      hours = "0" + hours
    } 
    // Display the result in the element with id="demo"
  
    if(document.getElementById("countdowntimer") !== null){
      
      //document.getElementById("countdowntimer").innerHTML = days + hours + minutes + seconds;
      
      document.getElementById("countdowntimer").innerHTML = hours + ":"
      + minutes + ":" + seconds;
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdowntimer").innerHTML = "EXPIRED";
      }
    }
  }, 1000);


/* ADA CODE FOR CART COUNTER */
  const headerObserverTarget = document.querySelector(".Header__CartDot");
  
  const cartDrawers = document.querySelectorAll('a[data-drawer-id="sidebar-cart"]')
  const ariaDefaultValue = cartDrawers[0].getAttribute("aria-label");
  let ariaValueToBe = ""
  const cdConfig = {
   subtree: true,
   attributeOldValue: true
  };
  
  const cdcallback = (mutationList) => {
   for (const mutation of mutationList) {
    if (mutation.type === "attributes") {
     if (mutation.target.classList.contains("is-visible")) {
      ariaValueToBe = `${ariaDefaultValue} - items added`
     } else {
      ariaValueToBe = `${ariaDefaultValue} - no items`
  
     } cartDrawers.forEach(cd => {
      cd.setAttribute("aria-label", ariaValueToBe)
     })
    }
   }
  };
  
  const cdObserver = new MutationObserver(cdcallback);
  cdObserver.observe(headerObserverTarget, cdConfig);

/* ADJUST DRAWER CONTENT HEIGHT */
  function adjustDrawerContentHeight() {
    const drawerContent = document.querySelector('#sidebar-cart .Drawer__Content');
    const drawerContainer = document.querySelector('#sidebar-cart .Drawer__Container');
    const announcementSection = document.querySelector('#shopify-section-announcement');

    if (drawerContent && drawerContainer && announcementSection) {
      const drawerContainerHeight = drawerContainer.offsetHeight;
      const announcementHeight = announcementSection.offsetHeight;
      
      const windowHeight = window.innerHeight;
      const newHeight = windowHeight - drawerContainerHeight - announcementHeight;

      drawerContent.style.height = `${newHeight}px`;
    }
  }

  window.addEventListener('load', adjustDrawerContentHeight);
  window.addEventListener('resize', adjustDrawerContentHeight);
